import VendorTagsEditorConnected from "./VendorTagsEditorConnected";

/** Custom Tags row for My Vendors cards. */
export default function MyVendorCardTagsField({ providerId, sponsorId = null, className = "" }) {
  return (
    <VendorTagsEditorConnected
      providerId={providerId}
      sponsorId={sponsorId}
      size="sm"
      className={className}
    />
  );
}
